import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faGear } from '@fortawesome/free-solid-svg-icons';
import { NotificationApplication, Subscription } from '@/core/notifications/model';
import { NotificationStatusFilter } from '@/core/notifications/hooks/use-notification-inbox';
import { CheckboxRow, EyebrowLabel } from '@/shared/components/export';

export const STATUS_OPTIONS: { value: NotificationStatusFilter; label: string }[] = [
  { value: 'all', label: 'All' },
  { value: 'unread', label: 'Unread' },
  { value: 'read', label: 'Read' },
];

export default function NotificationFilterPanel({
  applications,
  subscriptions,
  selectedPublishers,
  togglePublisher,
  selectedSubscriptions,
  toggleSubscription,
  statusFilter,
  setStatusFilter,
  onManageSubscriptions,
}: {
  applications: NotificationApplication[];
  subscriptions: Subscription[];
  selectedPublishers: Set<string>;
  togglePublisher: (id: string) => void;
  selectedSubscriptions: Set<string>;
  toggleSubscription: (id: string) => void;
  statusFilter: NotificationStatusFilter;
  setStatusFilter: (s: NotificationStatusFilter) => void;
  /** Shown next to the "Subscriptions" label as a shortcut to subscription management. */
  onManageSubscriptions?: () => void;
}) {
  return (
    <div
      className="border-end p-3 overflow-y-auto d-flex flex-column flex-shrink-0"
      style={{ width: 180 }}
    >
      {/* Status filter */}
      <EyebrowLabel muted spacing="md">
        Status
      </EyebrowLabel>
      <div className="d-flex flex-column gap-1 mb-3">
        {STATUS_OPTIONS.map(opt => (
          <button
            key={opt.value}
            onClick={() => setStatusFilter(opt.value)}
            className="btn btn-sm text-start border-0 rounded statusFilterButton"
            style={{
              background:
                statusFilter === opt.value ? 'rgba(var(--bs-primary-400-rgb), 0.18)' : 'none',
              opacity: statusFilter === opt.value ? 1 : 0.7,
              fontSize: 13,
              fontWeight: statusFilter === opt.value ? 600 : 400,
              padding: '4px 8px',
            }}
          >
            {opt.label}
          </button>
        ))}
      </div>

      {/* Applications */}
      {applications.length > 0 && (
        <>
          <EyebrowLabel muted spacing="md">
            Applications
          </EyebrowLabel>
          <div className="mb-3">
            {applications.map(app => (
              <CheckboxRow
                key={app.id}
                checked={selectedPublishers.has(app.id)}
                onChange={() => togglePublisher(app.id)}
                label={app.name}
              />
            ))}
          </div>
        </>
      )}

      {/* Subscriptions — manage-subscriptions shortcut sits next to the label */}
      {subscriptions.length > 0 && (
        <>
          <div className="d-flex align-items-center justify-content-between">
            <EyebrowLabel muted spacing="md">
              Alarms
            </EyebrowLabel>
            <button
              type="button"
              onClick={onManageSubscriptions}
              title="Manage alarms"
              className="btn btn-sm p-0 border-0 bg-transparent manageSubscriptionsButton"
              style={{ fontSize: 13, opacity: 0.75, marginBottom: 8 }}
            >
              <FontAwesomeIcon icon={faGear} />
            </button>
          </div>
          {subscriptions.map(sub => (
            <CheckboxRow
              key={sub.id}
              checked={selectedSubscriptions.has(sub.id)}
              onChange={() => toggleSubscription(sub.id)}
              label={sub.name}
            />
          ))}
        </>
      )}
    </div>
  );
}
